module.exports = __webpack_public_path__ + "img/laugh-wink.d40a8100.svg";